/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { observer } from 'mobx-react'
import uuid from 'uuid'
import useRootStore from '@store/useRootStore'
import { setCookie } from '@utils/utils'
import { COOKIE_KEYS } from '@constants/index'
import { Modal } from 'antd-mobile'
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react'
import SwiperCore, { Navigation, Pagination, EffectFade } from 'swiper'
import { AdvDialogStyle } from '@styles/modal'
import { isMobile } from 'react-device-detect'
// img
import TutorialImg01 from '@assets/images/tutorial/ttr01.png'
import TutorialImg02 from '@assets/images/tutorial/ttr02.png'
import TutorialImg03 from '@assets/images/tutorial/ttr03.png'
import TutorialImg04 from '@assets/images/tutorial/ttr04.png'
import TutorialImg05 from '@assets/images/tutorial/ttr05.png'
import TutorialImg06 from '@assets/images/tutorial/ttr06.png'
import TutorialImg07 from '@assets/images/tutorial/ttr07.png'
import TutorialImg08 from '@assets/images/tutorial/ttr08.png'
import TutorialImg09 from '@assets/images/tutorial/ttr09.png'
// css
import { ModalBg } from '@styles/base.style'
import { Button } from '@styles/button.style'
import { CarouselWrap } from '@views/Matchup/MatchUpBanner/index.style'
import { TutorialWrap } from './index.style'
import dayjs from 'dayjs'


SwiperCore.use([Navigation, Pagination, EffectFade])

if (!isMobile) {
  SwiperCore.extendDefaults({ allowTouchMove: false })
}

const TutorialPopup: React.FC = () => {
  const { globalStore } = useRootStore()
  const { visibleTutorialPopup } = globalStore

  const list = [
    {
      tutorialImgUrl: TutorialImg01,
      closeBtn: false,
    },
    {
      tutorialImgUrl: TutorialImg02,
      closeBtn: false,
    },
    {
      tutorialImgUrl: TutorialImg03,
      closeBtn: false,
    },
    {
      tutorialImgUrl: TutorialImg04,
      closeBtn: false,
    },
    {
      tutorialImgUrl: TutorialImg05,
      closeBtn: false,
    },
    {
      tutorialImgUrl: TutorialImg06,
      closeBtn: false,
    },
    {
      tutorialImgUrl: TutorialImg07,
      closeBtn: false,
    },
    {
      tutorialImgUrl: TutorialImg08,
      closeBtn: false,
    },
    {
      tutorialImgUrl: TutorialImg09,
      closeBtn: false,
    },
  ]

  const onCloseModal = () => {
    const expires = dayjs().endOf('year')
    setCookie(COOKIE_KEYS.TUTORIAL_DISPLAYED_BY_CIVALUE, 'true', expires.toDate())
    globalStore.setVisibleTutorialPopup(false)
  }

  const isLastIndexFromSwiperList = (index: number) => {
    const lastIndex = list.length - 1
    return index === lastIndex
  }

  // 튜토리얼 이미지
  let slides = []
  slides = list.map((tutorial, index) =>
      <Fragment key={uuid.v4()}>
        <img key={`MatchUpBanner:Swiper:Slide:${String(index)}`} src={tutorial.tutorialImgUrl} alt="튜토리얼 이미지" className="img"/>
        {isLastIndexFromSwiperList(index) && (<Button secondary className="cls-btn" onClick={onCloseModal}>닫기</Button>)}
      </Fragment>
    ,
  )

  return (
    <Modal
      visible={visibleTutorialPopup}
      transparent
      maskClosable={false}
      onClose={onCloseModal}
      wrapClassName="tutorial"
      className="event"
      css={AdvDialogStyle}
    >
      <TutorialWrap className={!isMobile && 'tutorial-pc'}>
        <Button TP className="cls-x-btn" onClick={onCloseModal}>
          <span className="x-ico"/>
        </Button>
        <CarouselWrap>
          <Swiper
            effect='fade'
            navigation={!isMobile}
            slidesPerView={1}
            speed={10}
          >
            {slides.map((slideImg, index) => (
              <SwiperSlide key={`MatchUpBanner:Swiper:Slide:Item:${String(index)}`}>
                {slideImg}
              </SwiperSlide>
            ))}
          </Swiper>
        </CarouselWrap>
      </TutorialWrap>

      <ModalBg className="dialog-bg"/>
    </Modal>
  )
}

export default observer(TutorialPopup)
